import { Overrides } from '@material-ui/core/styles/overrides';
import pallete from '../palette';

const MuiTab: Overrides['MuiTab'] = {
  root: {
    color: `${pallete.common.black}`,
    '&$selected': {
      color: `${pallete.primary.dark}`,
    },
    fontWeight: 700,
  },
};

export default MuiTab;
